import {Extracts} from '~/features/Extracts';

export const ExtractsScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <Extracts />
    </div>
  );
}; 